import { useState } from 'react';
import { Button } from '@mui/material';

import { useForceAPIErrorMutation, useForceAPIHandlerErrorMutation } from '../../store/index.js';

const ForceError: FC = () => {
    const [forceAPIHandlerError] = useForceAPIHandlerErrorMutation();
    const [forceAPIError] = useForceAPIErrorMutation();
    const [renderError, setRenderError] = useState(false);

    if (renderError) {
        throw new Error('Test render error');
    }

    return (
        <div>
            <Button
                variant="contained"
                color="error"
                onClick={() => {
                    throw new Error('Test handler error');
                }}
            >
                Handler Error
            </Button>
            <Button
                variant="contained"
                color="error"
                onClick={() => {
                    setRenderError(true);
                }}
            >
                Render Error
            </Button>
            <Button
                variant="contained"
                color="error"
                onClick={() => {
                    forceAPIHandlerError();
                }}
            >
                API Handler Error
            </Button>
            <Button
                variant="contained"
                color="error"
                onClick={() => {
                    forceAPIError();
                }}
            >
                API Error
            </Button>
        </div>
    );
};

export default ForceError;
